<template>
  <div
    class="relative mt-36 flex items-center justify-center w-full py-12 mx-auto"
  >
    <div class="text-center w-max border-2 border-blue-500 rounded-2xl">
      <div>
        <div class="p-6 mx-auto">
          <span
            class="
              mb-8
              text-xs
              font-semibold
              tracking-widest
              text-blue-600
              uppercase
            "
          >
            Sitra Employment Service
          </span>
          <strong
            class="
              flex
              items-end
              justify-center
              mx-auto
              mt-4
              mb-8
              text-3xl
              font-black
              leading-none
              text-center text-blue-600
              lg:text-4xl
            "
          >
            {{ amountStatus ? ` &#8377; ${amount} ` : "LOADING" }}
            <span class="text-sm text-gray-500"> /One time </span>
          </strong>
          <span
            class="mx-auto font-semibold leading-none tracking-tighter text-3xl"
          >
            Your Payment is being processed
          </span>
          <div class="mt-10 flex items-center justify-center">
            <div>
              <img
                src="../assets/mobile-phone.png"
                class="w-24 h-24 animate-bounce"
                alt="verifying"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useRouter } from "vue-router";
export default {
  data() {
    return {
      router: useRouter(),
      loading: false,
      amount: Number(),
      amountStatus: false,
    };
  },
  created() {
    this.getAmount();
    this.sendRes();
  },
  methods: {
    sendRes() {
      this.loading = true;
      if (sessionStorage.key(1) === "millId") {
        let d = JSON.stringify({
          custid: sessionStorage.getItem("millId"),
        });
        axios
          .post(
            `https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/onlineserviceapi/index.php/api/emphub_payment_status`,
            d
          )
          .then((res) => {
            // console.log(res.data[0].res_order_status);
            if (res.data[0].res_order_status == "Success") {
              let jdata = JSON.stringify({
                reqId: sessionStorage.getItem("reqId"),
                status: "Success",
                userType: "Mill",
              });
              axios
                .post(
                  ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/updatePayment`,
                  jdata
                )
                .then((res) => {
                  if (res.data) {
                    sessionStorage.removeItem("reqId");
                    setTimeout(() => {
                      this.router.push({ name: "MillDashboard" });
                    }, 2000);
                  }
                })
                .catch((err) => console.log(err));
            } else {
              let jdata = JSON.stringify({
                reqId: sessionStorage.getItem("reqId"),
                status: "Failure",
                userType: "Mill",
              });
              axios
                .post(
                  ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/updatePayment`,
                  jdata
                )
                .then((res) => {
                  if (res.data) {
                    sessionStorage.removeItem("reqId");
                    setTimeout(() => {
                      this.router.push({ name: "MillDashboard" });
                    }, 2000);
                  }
                })
                .catch((err) => console.log(err));
            }
          })
          .catch((err) => console.log(err));
      } else if (sessionStorage.key(0) === "id") {
        let d = JSON.stringify({
          custid: sessionStorage.getItem("id"),
        });
        axios
          .post(
            `https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/onlineserviceapi/index.php/api/emphub_payment_status`,
            d
          )
          .then((res) => {
            // console.log(res.data[0].res_order_status);
            if (res.data[0].res_order_status == "Success") {
              let jdata = JSON.stringify({
                regId: sessionStorage.getItem("id"),
                status: "Success",
              });
              axios
                .post(
                  ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/updatePayment`,
                  jdata
                )
                .then((res) => {
                  // console.log(res.data);
                  if (!res.data) {
                    setTimeout(() => {
                      this.router.push({ name: "subscription" });
                    }, 2000);
                  }
                })
                .catch((err) => console.log(err));
            } else {
              let jdata = JSON.stringify({
                reqId: sessionStorage.getItem("id"),
                status: "Failure",
              });
              axios
                .post(
                  ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/updatePayment`,
                  jdata
                )
                .then((res) => {
                  if (!res.data) {
                    setTimeout(() => {
                      this.router.push({ name: "subscription" });
                    }, 2000);
                  }
                })
                .catch((err) => console.log(err));
            }
          })
          .catch((err) => console.log(err));
      }

      this.loading = false;
    },
    getAmount() {
      if (sessionStorage.key(0) === "millId") {
        let jdata = JSON.stringify({
          userType: "Mill",
          regId: sessionStorage.getItem("millId"),
        });
        axios
          .post(
            ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/GETUserAmount`,
            jdata
          )
          .then((res) => {
            if (res.data.data.length >= 0) {
              let d = [...res.data.data];
              this.amount = d[0].fee;
              this.amountStatus = true;
              // console.log(this.amount);
            }
          });
      } else if (sessionStorage.key(0) === "id") {
        let jdata = JSON.stringify({
          userType: "Candidate",
          regId: sessionStorage.getItem("id"),
        });
        axios
          .post(
            ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/GETUserAmount`,
            jdata
          )
          .then((res) => {
            if (res.data.data.lenght >= 0) {
              let d = [...res.data.data];
              this.amount = d[0].fee;
              this.amountStatus = true;
            }
          });
      }
    },
  },
};
</script>

<style></style>
